function ButtonBack() {
  const handleGoBack = (e) => {
    e.preventDefault();
    window.history.back();
  };

  return (
    <a className="btn" onClick={handleGoBack}>
      ย้อนกลับ
    </a>
  );
}

export default ButtonBack;